export class MapRoutes {
  static readonly SisId = 'sisId';
  static readonly Alias = 'alias';
  static readonly Season = 'season';
}
